/**
 * Various commands
 */
export enum PoodleCommands {
  /**
   * Open the modal, called from outside
   */
  OPEN = "OPEN",
}
